import fonts from 'const/style/fonts';
import { inject, observer } from 'mobx-react';
import Login, { PrivacyPolicyContent } from 'models/Login';
import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import colors from 'const/style/colors';

export const Frame = styled.div` 
 margin:30px;

.frame-titie{
  display:flex;
  flex-direction:row;
  justify-content:space-between;

  h1{
    ${fonts.H1_Bold};
  }
  select{
    width:200px;
  }
}

.frame-content{
  margin-top:30px;
  padding:30px;
  background: rgba(220,220,220,0.2);
  color:black;
  white-space:pre-line;
  text-align:left;
  b {
    font-weight:600;
  }
}
`;

interface IPrivacyTerms {
  loginInfo?: Login;
}

const PrivacyTerms: FC<IPrivacyTerms> = (props: IPrivacyTerms) => {
  const { loginInfo } = props;
  const [content, setContent] = useState<PrivacyPolicyContent>();

  useEffect(() => {
    const init = async () => {
      await loginInfo!.getCompanyInfo();
      if(loginInfo!.companyInfo!.privacyPolicyContents[0])
        setContent(loginInfo!.companyInfo!.privacyPolicyContents[0]);
    }
    init();
  }, [])
  useEffect(() => {
  
  }, [content])

  const onChangeSelect=(data:any)=>{
   let selectedContent= loginInfo!.companyInfo!.privacyPolicyContents!.find((content:PrivacyPolicyContent) => {
      if(content.privacyPolicySn==data.target.value)return content;
    })
    setContent(selectedContent);
  }

  if (loginInfo!.companyInfo === undefined) return <div></div>
  // if (content === undefined) return <div></div>
  return (
    <Frame>
      <div className='frame-titie'>
       {content? <h1>{content!.privacyPolicyName}</h1> : <h1>개인정보 처리방침</h1>} 
        <select name="privacyList" id="privacyList" onChange={onChangeSelect} >
        <option value="" disabled hidden>선택해 주세요.</option>
          {content&&
            loginInfo?.companyInfo?.privacyPolicyContents.map((data:PrivacyPolicyContent) => {
             return <option key={data.privacyPolicySn} value={data.privacyPolicySn}>{data.privacyPolicyName}</option>
            })
          }
        </select>
      </div>
      <div className='frame-content' dangerouslySetInnerHTML={{
         __html: content? content!.privacyPolicyContents:'개인정보 처리방침을 불러올 수 없습니다.' }} />
    </Frame>
  )
};

export default inject('loginInfo')(observer(PrivacyTerms));
